import store from '../redux/store'
import AuthService from '../services/AuthService'
import { Actions } from '../redux/actions/action'

const DELETE = request('DELETE')
const GET = request('GET')
const POST = request('POST')
const PUT = request('PUT')
const PATCH = request('PATCH')

function request(method: string) {
  return async (url: string, payload?: any) => {
    // Refresh token before every API request to ensure it's valid
    // Checks if token expires within 60s and refreshes if needed (see HBGPPH-2134)
    try {
      await AuthService.updateToken((refreshed) => {
        // Only update Redux if token was actually refreshed
        if (refreshed) {
          store.dispatch({
            type: Actions.USER_DETAILS.UPDATE_USER,
            payload: AuthService.getUser()
          })
        }
        return refreshed
      })
    } catch (error) {
      console.error('Token refresh failed:', error)
      // AuthService.doLogin() is called automatically by updateToken on failure
    }

    const requestOptions: any = {
      method,
      headers: authHeader(url)
    }
    if (payload) {
      if (payload.contentType) {
        requestOptions.headers['Content-Type'] = payload.contentType
      }
      if (payload.body) {
        requestOptions.body = payload.body
      }
    }

    if (payload?.filename) {
      return fetch(url, requestOptions).then((response) =>
        handleFileFetchResponse(response, payload.filename)
      )
    } else {
      return fetch(url, requestOptions).then(handleFetchResponse)
    }
  }

  // Private helper methods
  function authHeader(url: string) {
    const token = store.getState().userDetails.token
    if (url && token) {
      return { Authorization: `Bearer ${token}` }
    } else {
      return {}
    }
  }

  async function handleFetchResponse(response: any) {
    if (response.ok) {
      return response.json().catch(() => null) // in some cases we don't receive a response, only a status code. (empty response body).json() => error, which is caught here
    } else {
      throw await response.json()
    }
  }

  async function handleFileFetchResponse(response: any, filename: string) {
    // To read the byte array in full, we make use of the blob() function of the response
    response.blob().then((blob: Blob) => {
      // As the browsers currently don't support a standard way of downloading files from a request,
      // we have to create an object URL for the incoming Blob and force the browser to download the image with a hidden <a> HTML element.
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      return true
    })
  }
}

const FetchWrapper = {
  GET,
  POST,
  PUT,
  PATCH,
  DELETE
}

export default FetchWrapper
